var exports = {
  "k": "xaf9ae18d--e97de7--container",
  "S": "xaf9ae18d--e97de7--opened",
};

module.exports = exports;
